import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { ConciliationHeaderDataGrid, ConciliationHeaderSearch } from '../components';
import FiltersLayoutHandler from '../components/FiltersLayoutHandler';
import { reportConciliationHeaderLoadingSelector } from '../state';
import ConciliationHeaderInfoCards from '../components/ConciliationHeaderInfoCards';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  '.MuiToolbar-root': {
    marginTop: theme.spacing(3),
  },
}));

const ConciliationHeader = () => (
  <Container>
    <Typography variant="h6" color="text.primary" sx={{ ml: 2, mb: 2, fontWeight: 'bold' }}>
      Restaurant Conciliations
    </Typography>
    <FiltersLayoutHandler selector={reportConciliationHeaderLoadingSelector}>
      <ConciliationHeaderSearch />
    </FiltersLayoutHandler>
    <ConciliationHeaderInfoCards />
    <ConciliationHeaderDataGrid />
  </Container>
);

export default ConciliationHeader;
